<template>
  <div>
    <div style="margin-top: 50px;" v-if="loading" v-loading="loading" element-loading-spinner="atom-audit-loader"></div>
    <div v-if="!loading">
      <div v-for="worksheet in worksheets" :key="worksheet.patientNumber" class="page-break" style="margin-bottom: 50px;">
        <h3>Inpatient Review Worksheet</h3>
        <InpatientWorksheet :worksheet="worksheet" :optionalParameters="optionalParameters"></InpatientWorksheet>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import { format, parseISO } from 'date-fns'
  import InpatientWorksheet from '@/views/reviews/inpatient/worksheets/InpatientWorksheet.vue'
  import axios from '@/utilities/axios-global'

  export default {
    name: 'Worksheets',
    props: ['drgTableIds', 'showDrgWorksheets', 'showFyiWorksheets', 'optionalParameters'],
    data() {
      return {
        loading: true,
        worksheets: [],
        format: format,
        parseISO: parseISO,
        dropdownsNeeded: ['RecommendationTypes', 'RecommendationRecordTypes', 'RecommendationCodeGroups', 'clients']
      }
    },
    components: {
      InpatientWorksheet
    },
    methods: {
      async getWorksheets() {
        this.loading = true
        const ids = {
          ids: this.drgTableIds
        }
        if (this.inpatientReviewer()) {
          const response = await axios.post(this.baseApiUrl + `/reviews/inpatient/worksheets?includeDrgWorksheets=${this.showDrgWorksheets}&includeFyiWorksheets=${this.showFyiWorksheets}&includeNoChangeWorksheets=false`, ids)

          this.worksheets = response.data
        }

        if (!this.inpatientReviewer() && this.coder()) {
          const response = await axios.post(this.baseApiUrl + `/coder/inpatient/worksheets?includeDrgWorksheets=${this.showDrgWorksheets}&includeFyiWorksheets=${this.showFyiWorksheets}&includeNoChangeWorksheets=false`, ids)

          this.worksheets = response.data
        }

        this.loading = false
      }

    },
    mounted: async function () {
      await this.getWorksheets()
    },
    watch: {
      showDrgWorksheets: function () {
        this.getWorksheets()
      },
      showFyiWorksheets: function () {
        this.getWorksheets()
      }
    },
    computed: {
      ...mapState('user/', ['baseApiUrl']),
      ...mapState('managedLists/tenantSetup/', ['tenantSetup'])
    }
  }
</script>

<style scoped>
  @media print {
    .page-break {
      display: block;
      page-break-after: always;
    }

    .print-hidden {
      display: none;
    }
  }
</style>